import * as React from 'react'

import { IItemCard } from '../interface'
import AudioPlayer from './audioPlayer'

import ItemCardSmallPreview from '../itemCardSmallPreview'

import * as styles from './lockupAudioPreview.module.css'

const LockupAudioPreview = (props: IItemCard) => (
  <div className={styles.root}>
    <span className={styles.icon}>
      <ItemCardSmallPreview {...props} />
    </span>
    <AudioPlayer item={props.item} viewType={props.viewType} />
  </div>
)

export default LockupAudioPreview
